import React from "react";
import "./Footer.css";
import logo from "../../Asset/Icons/logo_transparent.png";
import qrImage from "../../Asset/Images/QR_Payment2.jpeg";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

const Footer = () => {

  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* ABOUT */}
        <div className="footer-about">
          <img
            src={logo}
            alt="Maanavta Hitaay Seva Chatra Logo"
            className="footer-logo"
          />

          <p>
            {t("footer_about")}
          </p>

          <div className="footer-socials">

            {/* External links remain <a> */}
            <a href="https://wa.me/917066883322" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp">
              <FaWhatsapp />
            </a>

            <a href="https://www.facebook.com/share/1AWhuCQVzH/" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
              <FaFacebookF />
            </a>

            <a href="https://www.instagram.com/maanavta_hitay?igsh=MXc1N3dkY2Z2b2g3ZA==" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
              <FaInstagram />
            </a>

            <a href="https://www.youtube.com/@manavtahitay-ek8hv" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
              <FaYoutube />
            </a>

          </div>
        </div>

        {/* IMPORTANT LINKS */}
        <div className="footer-links">
          <h4>{t("footer_links_title")}</h4>

          <Link to="/KnowAboutOrg">{t("nav_about")}</Link>
          <Link to="/VisionMission">{t("nav_mission")}</Link>
          <Link to="/GovBody">{t("nav.about.team")}</Link>
          <Link to="/DocumentsRequired">{t("nav_gallery")}</Link>
          <Link to="/Contactus">{t("nav_contact")}</Link>
          <Link to="/FAQ">{t("nav_faq")}</Link>

          {/* Cookie Policy */}
          <Link to="/CookiePolicy">{t("cookie_policy")}</Link>
          <Link to="/termsConditions">{t("terms_cond")}</Link>

        </div>

        {/* SERVICES */}
        <div className="footer-links">
          <h4>{t("footer_services_title")}</h4>

          <Link to="/AssistedLiving">{t("service_assisted_living")}</Link>
          <Link to="/DementiaCare">{t("service_dementia")}</Link>
          <Link to="/PalliativeCare">{t("service_palliative")}</Link>
          <Link to="/MedicalSupport">{t("service_medical")}</Link>
          <Link to="/MealsNutrition">{t("nav.services.meals")}</Link>
          <Link to="/FamilyConsults">{t("nav.services.consults")}</Link>
          <Link to="/RecoveryRehab">{t("service_rehab")}</Link>
        </div>

        {/* DONATION */}
        <div className="footer-donate">
          <h4>{t("footer_support_title")}</h4>

          <div className="qr-card">
            <img src={qrImage} alt="Donate via UPI QR" />

            <p className="upi-id">
              {t("footer_upi")} <span>7066883322@ucobank</span>
            </p>

            <p className="scan-text">
              {t("footer_scan")}
            </p>
          </div>
        </div>

      </div>

      {/* COPYRIGHT */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} {t("footer_copyright")}
      </div>

    </footer>
  );
};

export default Footer;